import ActionType from 'actions/ActionType'

export default (state = false, action) => {
	switch (action.type) {
		case ActionType.SignupForm.ADD_REQUEST:
			return true
		case ActionType.SignupForm.UPDATE_REQUEST:
			return true
		case ActionType.SignupForm.VALIDATION_FAILURE:
			return false
		case ActionType.SignupForm.ADD_FAILURE:
			return false
		case ActionType.SignupForm.UPDATE_FAILURE:
			return false
		case ActionType.SignupForm.RECEIVE_FORM:
			return false
		case ActionType.CustomForm.RECEIVE_FORM:
			return false
		case ActionType.Data.VALIDATION_FAILURE:
			return false
		case ActionType.Data.CREATE_REQUEST:
			return true
		case ActionType.Data.UPDATE_REQUEST:
			return true
		case ActionType.Data.UPDATE_FAILURE:
			return false
		default:
			return state
	}
}
